/**
 * batch-166/176 — poll cadence for the inbox list, the Needs-reply
 * summary/clocks, and the open thread.
 *
 * batch-176 — these surfaces are now driven by REAL-TIME SSE push
 * (`useRealtimeEvents` → invalidate on every change, Gmail-like). Polling is now
 * just the FALLBACK for when the SSE stream is down, so the tight 8s cadence is
 * no longer needed — relaxed to 30s (plus refetchOnWindowFocus/reconnect from
 * batch-166). If SSE is healthy, updates arrive in ~1s and this rarely fires.
 *
 * Slower surfaces (follow-ups, contacts/admin) keep their own intervals.
 */
export const LIVE_POLL_MS = 30_000;
